import React, { useEffect, useMemo, useRef, useState } from "react";
import "./conquistas.css";

const CATEGORIAS = {
  agua: {
    titulo: "Água",
    descricao: "Mantenha sua hidratação em dia",
    emoji: "💧",
  },
  streak: {
    titulo: "Sequência",
    descricao: "Continue usando o app todos os dias",
    emoji: "🔥",
  },
  refeicao: {
    titulo: "Refeições",
    descricao: "Registre suas refeições e evolua",
    emoji: "🍽️",
  },
  nivel: {
    titulo: "Nível",
    descricao: "Ganhe experiência e alcance novos níveis",
    emoji: "⭐",
  },
  moedas: {
    titulo: "Moedas",
    descricao: "Use moedas e aproveite os recursos do app",
    emoji: "🪙",
  },
  favoritos: {
    titulo: "Favoritos",
    descricao: "Monte sua coleção de refeições favoritas",
    emoji: "❤️",
  },
  perfil: {
    titulo: "Perfil",
    descricao: "Complete e mantenha seus dados atualizados",
    emoji: "👤",
  },
  geral: {
    titulo: "Geral",
    descricao: "Complete desafios especiais",
    emoji: "🏆",
  },
};

const Conquistas = ({ conquistas }) => {
  const [tooltipId, setTooltipId] = useState(null);
  const containerRef = useRef(null);

  const lista = Array.isArray(conquistas) ? conquistas : [];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setTooltipId(null);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setTooltipId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const grupos = useMemo(() => {
    const gruposMontados = [];
    const indicePorTipo = {};

    lista.forEach((item) => {
      const tipo = item.tipo || "geral";

      if (!(tipo in indicePorTipo)) {
        indicePorTipo[tipo] = gruposMontados.length;

        gruposMontados.push({
          tipo,
          itens: [],
        });
      }

      gruposMontados[indicePorTipo[tipo]].itens.push(item);
    });

    return gruposMontados;
  }, [lista]);

  const toggleTooltip = (id) => {
    setTooltipId((atual) => (atual === id ? null : id));
  };

  const handleTecladoMedalha = (event, id) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleTooltip(id);
    }
  };

  if (lista.length === 0) {
    return (
      <div className="conquistas-vazio">
        <div className="conquistas-vazio-icone">🏆</div>

        <strong className="conquistas-vazio-titulo">
          Nenhuma conquista disponível
        </strong>

        <span className="conquistas-vazio-texto">
          Novos desafios aparecerão aqui.
        </span>
      </div>
    );
  }

  return (
    <div className="conquistas-container" ref={containerRef}>
      {grupos.map((grupo, grupoIndex) => {
        const categoriaInfo =
          CATEGORIAS[grupo.tipo] || CATEGORIAS.geral;

        const total = grupo.itens.length;

        const desbloqueadas = grupo.itens.filter(
          (item) => item.desbloqueada
        ).length;

        const percentual =
          total > 0
            ? Math.round((desbloqueadas / total) * 100)
            : 0;

        const categoriaCompleta =
          total > 0 && desbloqueadas === total;

        return (
          <section
            className={`conquistas-secao ${
              categoriaCompleta
                ? "conquistas-secao-completa"
                : ""
            }`}
            key={grupo.tipo}
            style={{
              "--conquista-indice": grupoIndex,
            }}
          >
            <div className="conquistas-secao-topo">
              <div className="conquistas-secao-identidade">
                <div className="conquistas-secao-icone">
                  {categoriaInfo.emoji}
                </div>

                <div className="conquistas-secao-textos">
                  <div className="conquistas-secao-linha-titulo">
                    <h3 className="conquistas-secao-titulo">
                      {categoriaInfo.titulo}
                    </h3>

                    {categoriaCompleta && (
                      <span className="conquistas-completa-badge">
                        Completa
                      </span>
                    )}
                  </div>

                  <p className="conquistas-secao-descricao">
                    {categoriaInfo.descricao}
                  </p>
                </div>
              </div>

              <div className="conquistas-secao-contador">
                <strong>{desbloqueadas}</strong>
                <span>/</span>
                <span>{total}</span>
              </div>
            </div>

            <div className="conquistas-progresso-area">
              <div
                className="conquistas-progresso-barra"
                role="progressbar"
                aria-label={`Progresso da categoria ${categoriaInfo.titulo}`}
                aria-valuemin="0"
                aria-valuemax="100"
                aria-valuenow={percentual}
              >
                <div
                  className="conquistas-progresso-preenchimento"
                  style={{
                    width: `${percentual}%`,
                  }}
                >
                  <span className="conquistas-progresso-brilho" />
                </div>
              </div>

              <span className="conquistas-progresso-percentual">
                {percentual}%
              </span>
            </div>

            <div className="conquistas-grid">
              {grupo.itens.map((item, itemIndex) => {
                const isOpen = tooltipId === item.id;
                const desbloqueada = Boolean(item.desbloqueada);

                return (
                  <div
                    key={item.id}
                    className={`conquista-item ${
                      desbloqueada
                        ? "conquista-item-desbloqueada"
                        : "conquista-item-bloqueada"
                    } ${
                      isOpen
                        ? "conquista-item-tooltip-aberto"
                        : ""
                    }`}
                    style={{
                      "--conquista-item-indice": itemIndex,
                    }}
                  >
                    <button
                      type="button"
                      className="conquista-wrapper"
                      onClick={() => toggleTooltip(item.id)}
                      onKeyDown={(event) =>
                        handleTecladoMedalha(event, item.id)
                      }
                      aria-expanded={isOpen}
                      aria-label={
                        desbloqueada
                          ? `${item.titulo}. Conquista desbloqueada.`
                          : `${item.titulo}. Conquista bloqueada.`
                      }
                    >
                      <span className="conquista-base">
                        <span className="conquista-luz-fundo" />

                        <span className="conquista-imagem-area">
                          {item.imagem_url ? (
                            <img
                              src={item.imagem_url}
                              alt=""
                              className="conquista-imagem"
                              draggable="false"
                            />
                          ) : (
                            <span className="conquista-imagem conquista-imagem-emoji">
                              {item.icone ||
                                categoriaInfo.emoji}
                            </span>
                          )}
                        </span>

                        {!desbloqueada && (
                          <span
                            className="conquista-cadeado"
                            aria-hidden="true"
                          >
                            🔒
                          </span>
                        )}

                        {desbloqueada && (
                          <span
                            className="conquista-check"
                            aria-hidden="true"
                          >
                            ✓
                          </span>
                        )}
                      </span>

                      <span className="conquista-nome">
                        {item.titulo}
                      </span>

                      <span
                        className={`conquista-status ${
                          desbloqueada
                            ? "conquista-status-desbloqueada"
                            : "conquista-status-bloqueada"
                        }`}
                      >
                        {desbloqueada
                          ? "Desbloqueada"
                          : "Bloqueada"}
                      </span>
                    </button>

                    {isOpen && (
                      <div
                        className="conquista-tooltip"
                        role="tooltip"
                      >
                        <div className="conquista-tooltip-topo">
                          <span className="conquista-tooltip-icone">
                            {desbloqueada ? "🏆" : "🔒"}
                          </span>

                          <div>
                            <strong className="conquista-tooltip-titulo">
                              {item.titulo}
                            </strong>

                            <span
                              className={`conquista-tooltip-status ${
                                desbloqueada
                                  ? "conquista-tooltip-status-desbloqueada"
                                  : ""
                              }`}
                            >
                              {desbloqueada
                                ? "Conquista desbloqueada"
                                : "Conquista bloqueada"}
                            </span>
                          </div>
                        </div>

                        <p className="conquista-tooltip-descricao">
                          {desbloqueada
                            ? item.descricao ||
                              "Você concluiu esta conquista."
                            : item.descricao ||
                              "Continue evoluindo para desbloquear esta conquista."}
                        </p>

                        <span className="conquista-tooltip-seta" />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default Conquistas;